import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import FormControl from '@material-ui/core/FormControl';
import Input from 'fuse-ui/components/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Logo from '../../../assets/proofpoint-logo-white.svg';
import PropTypes from 'prop-types';
import ProofpointCopyright from './proofpoint-copyright';
import React from 'react';
import Typography from 'fuse-ui/components/Typography';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ( {
    button: {
        '&:hover': {
            backgroundColor: theme.palette.primary[900]
        },
        backgroundColor: theme.palette.primary[800],
        margin: '0 auto',
        padding: '8px 45px',
    },
    cardActions: {
        padding: '0 44px 24px'
    },
    cardContent: {
        padding: '24px 44px 40px'
    },
    cardHeader: {
        backgroundColor: theme.palette.primary[800],
        height: 56,
        paddingBottom: 5,
        textAlign: 'center'
    },
    cardHeaderTitle: {
        color: theme.palette.background.paper,
    },
    description: {
        color: theme.palette.text.secondary,
        margin: '24px 0 16px'
    },
    link: {
        textDecoration: 'none',
    },
    loginCard: {
        marginBottom: theme.spacing.unit * 2,
        width: 480
    },
    loginError: {
        color: theme.palette.error.main
    },
    main: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        height: '100vh',
        marginTop: '40px',
    },
    root: {
        alignItems: 'stretch',
        backgroundColor: theme.palette.grey[200],
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        justifyContent: 'center',
    },

} );

class Login extends React.Component{

    constructor( props ){
        super( props );

        this.state = {
            formIsClean: true,
            username: this.props.savedLoginEmail,
        };
    }

    handleUsernameChange = ( event ) => {
        this.setState( {
            formIsClean: false,
            username: event.target.value,
        } );
    }

    handleSubmit = ( event ) => {
        event.preventDefault();
        this.props.handleLogin( this.state.username.trim() );
    }

    isEmailInvalid = ( email ) => {
        // eslint-disable-next-line
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        const result = re.test( email );
        return !result && !this.state.formIsClean;
    }

    render(){
        const { classes, loginError, loginStatus } = this.props;
        const { username } = this.state;
        const errorMessageMap = {
            '401': 'Incorrect username or password',
            '403': 'Insufficient permissions'
        };

        return (
            <div className={classes.root}>
                <div className={classes.main}>
                    <Card className={classes.loginCard}>
                        <CardHeader
                            className={classes.cardHeader}
                            title={(
                                <img
                                    src={Logo}
                                    alt="Proofpoint Logo"
                                    height={24}
                                    className="logo"
                                />
                            )}
                        />
                        <form onSubmit={this.handleSubmit}>
                            <CardContent className={classes.cardContent}>
                                <Typography align="center" variant="h5" data-automation-id="login-card-title">
                                Welcome to Email Fraud Defense
                                </Typography>
                                <Typography align="left" className={classes.description} data-automation-id="login-card-description">
                                Look different? We've updated how users authenticate. If you are a current EFD customer
                                and still have trouble logging in, please contact EFDSupport@proofpoint.com. If you
                                are not a current EFD customer or currently evaluating EFD, you will not have sufficient
                                permission to log in; please contact your Account Manager for further information.
                                </Typography>
                                {
                                    loginError &&
                                ( <Typography variant="subtitle1" className={classes.loginError} align="center" data-automation-id="login-error-message">
                                    { errorMessageMap[loginStatus] }
                                </Typography> )
                                }
                                <FormControl fullWidth={true} required={true}>
                                    <InputLabel htmlFor="login-email-field">Email address</InputLabel>
                                    <Input
                                        autoFocus={true}
                                        error={this.isEmailInvalid( username ) || loginError}
                                        id="login-email-field"
                                        inputProps={{
                                            'data-automation-id': 'login-email-field'
                                        }}
                                        onChange={this.handleUsernameChange}
                                        value={username}
                                    />
                                </FormControl>
                            </CardContent>
                            <CardActions className={classes.cardActions}>
                                <Button
                                    className={classes.button}
                                    color="primary"
                                    data-automation-id="login-submit-button"
                                    type="submit"
                                    variant="contained"
                                >
                                Log In
                                </Button>
                            </CardActions>
                        </form>
                    </Card>
                    <ProofpointCopyright />
                </div>
            </div>
        );
    }
}

Login.propTypes = {
    classes: PropTypes.object,
    handleLogin: PropTypes.func,
    loginError: PropTypes.bool,
    loginStatus: PropTypes.number,
    savedLoginEmail: PropTypes.string,
};

Login.defaultProps = {
    savedLoginEmail: ''
};

export default withStyles( styles )( Login );
